import { InRow } from "common/Grid";
import { useState } from "react";

export const Form = ({ classNames, children, onEnter = null }) => (
  <div
    className={["ui-form  ", ...(classNames ?? [])].join(" ")}
    onKeyDown={(e) => {
      if (onEnter && e.key === "Enter") {
        onEnter();
      }
    }}>
    {children}
  </div>
);
export const FormField = ({
  classNames,
  direction = "col",
  label,
  labelAdditions,
  id,
  name,
  noErrors = false,
  required = false,
  inputFactory,
  errorMessage,
}) => {
  const [failedValidationResults, setFailedValidationResults] = useState([]);
  const [hasError, setHasError] = useState(false);
  const onValidation = (isValid, failedResults = []) => {
    setFailedValidationResults(failedResults);
    setHasError(!isValid);
  };
  const input = inputFactory(id, name ?? id, onValidation);
  const labelRenderer = () =>
    label !== undefined && label.trim().length > 0 ? (
      <label htmlFor={id}>
        {`${label}`}
        {required ? (
          <span className="required after:ml-1  after:text-red-500 after:text-[1.1rem] after:leading-4 after:align-baseline after:content-['*']"></span>
        ) : null}
        <span className="separator hidden ">{": "}</span>
      </label>
    ) : null;
  const allClassNames = [
    `ui-form-field p-[0.25rem] text-black flex flex-${direction}`,
    hasError || errorMessage ? "has-errors text-red-500" : "",
    ...(classNames ?? []),
  ];
  return (
    <div className={allClassNames.join(" ")}>
      {labelAdditions ? (
        <InRow>
          {labelRenderer()}
          {labelAdditions}
        </InRow>
      ) : (
        <>{labelRenderer()}</>
      )}
      <div className={`control`}>{input}</div>
      {!noErrors && (errorMessage || failedValidationResults.length > 0) ? (
        <ul className="errors text-sm lowercase">
          {errorMessage ? (
            <li>{errorMessage}</li>
          ) : (
            failedValidationResults.map((x) => (
              <li key={x.name}>{x.message}</li>
            ))
          )}
        </ul>
      ) : null}
    </div>
  );
};
